// Module
var code = "<div class=\"full-height\" layout=\"column\"> <bringoz-items-list-display max-items=\"1\" items=\"$ctrl.barcodes\"></bringoz-items-list-display> </div> ";
// Exports
export default code;